import React, { useEffect } from 'react'
import { Grid } from 'react-flexbox-grid'
import queryString from 'query-string'
import { post } from '../../services/utils'
import { sendToSlack } from '../../services/slack'

const REACT_APP_PAYPAL_CALLBACK = process.env.REACT_APP_PAYPAL_CALLBACK
const REACT_APP_BASE = process.env.REACT_APP_BASE
const PAYPAL_LINK = process.env.REACT_APP_PAYPAL_LINK

const CHARSET = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~'

const PayPal = ({ match, location }) => {
  const randomString = (length) => {
    const bytes = new Uint8Array(length)
    const random = window.crypto.getRandomValues(bytes)
    let result = []
    random.forEach((number) => {
      result.push(CHARSET[number % CHARSET.length])
    })
    return result.join('')
  }

  const getTokenFromNavigationParameters = () => {
    return match.params.token
  }

  const getQueryStringParameters = () => {
    return queryString.parse(location.search)
  }

  const authenticateWithPayPal = () => {
    const token = getTokenFromNavigationParameters()
    setPayPalTokenInLocalStorage(token)
    const nonce = randomString(12)
    window.location = `${REACT_APP_PAYPAL_CALLBACK}=${nonce}&newUI=Y`
  }

  const setPayPalTokenInLocalStorage = (value) => {
    window.localStorage.setItem('temporal-token', value)
  }

  const getPayPalTokenFromLocalStorage = () => {
    return window.localStorage.getItem('temporal-token')
  }

  const linkPayPalAccount = async () => {
    try {
      const token = getPayPalTokenFromLocalStorage()
      const values = getQueryStringParameters()

      const response = await post(PAYPAL_LINK, { token, code: values.code })
      if (response && response.error) {
        const { errorCode } = response
        handleOnErrorLinkResponse(errorCode)
        return
      }

      successCallback()
    } catch (error) {
      handleOnErrorLinkResponse(error)
    } finally {
      setPayPalTokenInLocalStorage('NULL')
    }
  }

  const handleOnErrorLinkResponse = (error) => {
    errorCallback({ code: error })
  }

  const successCallback = () => {
    window.location = `${REACT_APP_BASE}/paypal-ok`
  }

  const errorCallback = (errorCode) => {
    window.location = `${process.env.REACT_APP_BASE}/paypal-error?type=${JSON.stringify(errorCode)}`
  }

  const isCallbackAction = () => {
    const token = getTokenFromNavigationParameters()
    return token === 'callback'
  }

  useEffect(() => {
    const token = match.params.token
    if (token.length <= 0 || token === '') {
      sendToSlack({
        title: `[WEB APP] - Se ha producido al enlazar una cuenta de paypal`,
        token
      })
      return
    }

    // Is not a callback action, so we need to authenticate the user against PayPal
    if (!isCallbackAction()) {
      authenticateWithPayPal()
    }

    if (isCallbackAction()) {
      linkPayPalAccount()
    }
  }, [match.params.token])

  return <Grid fluid />
}

export default PayPal



// WEBPACK FOOTER //
// ./src/pages/PayPal/index.js